module.exports = __webpack_public_path__ + "static/45-future-of-work-encouraging-diversity-and-retaining-talent-in-2020-e6530dfbbb5fc8b334fa6e00da17b31f.png";